import { rootReducer } from '@wellesley/store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type SystemToastState = {
  toastsSizes: Record<ID, number>
}

type ID = string

const initialState: SystemToastState = {
  toastsSizes: {}, // array of toasts sizes
}

type ToastPayload = {
  id: ID
  size: number
}

const systemToastSlice = createSlice({
  name: 'systemToast',
  initialState,
  reducers: {
    addToastSize(state, action: PayloadAction<ToastPayload>) {
      const { id, size } = action.payload
      state.toastsSizes[id] = size
    },
    removeToastSize(state, action: PayloadAction<ID>) {
      delete state.toastsSizes[action.payload]
    },
  },
  selectors: {
    selectToastSize: (state) =>
      Math.max(0, ...Object.values(state.toastsSizes)),
  },
}).injectInto(rootReducer)

export const { addToastSize, removeToastSize } = systemToastSlice.actions
export const { selectToastSize } = systemToastSlice.selectors
